// extracted by mini-css-extract-plugin
export default {"spinner":"IwAGbeOh","rotate":"Xj4j39RC"};